<template>
  <div class="form-page step-1">
    <!-- 1 -->
    <div class="form-icon__wrap" v-for="(value, name, index) in options" :key="index">
      <div
        class="form-icon"
        :name="currentField.name"
        @click="handleInput(value)"
        :class="{ success: currentField.value === value }"
      >
        <img :src="getImgUrl(icons[index]) || ''" alt="" />
        <p>{{ name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'IconButtonPicker',
  mounted() {},
  computed: {
    ...mapState({
      history: (state) => state.history,
      currentStep: (state) => state.currentStep,
      currentField: (state) => state.history[state.currentStep],
      additionalParams: (state) => state.additionalParams,
    }),
    options() {
      return this.currentField.field.translate
    },
    icons() {
      return this.currentField.field.icons
    },
  },
  methods: {
    getImgUrl(pic) {
      let prefix = ''
      // comment
      if (window.newDesign) prefix = '/newDesign'
      if (window.location.href.includes('finteres')) prefix = '/finteres'
      if (window.location.href.includes('cashspace')) prefix = '/cashspace'
      try {
        return pic
          ? `https://cdn.crezu.net/game_flow/src/assets/img${prefix}/i-${pic}.svg`
          : `https://cdn.crezu.net/game_flow/src/assets/img/i-other.svg`
      } catch (e) {
        return ''
      }
    },
    handleInput(val) {
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: val })
      this.$store.dispatch('nextStepPrepare', +1)
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/fields/IconButtonPicker.vue